import { classNames } from "primereact/utils";

const chip = {
    root: {
        className: classNames('inline-flex items-center', 'bg-white border border-grey-4 text-gray-800 rounded-[16px] px-2 dark:text-white/80 dark:bg-gray-900')
    },
    label: 'leading-4 text-sm my-1',
    icon: 'leading-4 mr-2',
    image: {
        className: classNames('w-9 h-9 ml-[-0.75rem] mr-2', 'rounded-full')
    },
    removeIcon: {
        className: classNames('ml-2 rounded-md transition duration-200 ease-in-out', 'cursor-pointer leading-6')
    }
}

export default chip;
    